// Shared chip used by both AdvancedResults and Shortlist to signal whether
// a degree's total cost sits inside the user's budget envelope.
//
// - Returns null when we don't have a total cost or a budget to compare against.
// - Uses net cost when available, else total degree cost.

export default function BudgetFitChip({ totalCost, netCost, budget, format, size = "md" }) {
  const cost = Number(netCost ?? totalCost ?? 0);
  if (!cost || !budget) return null;
  const over = cost - budget;
  const fits = over <= 0;
  const sizing = size === "sm"
    ? "text-[9px] px-1.5 py-0.5"
    : "text-[10px] px-2 py-0.5";
  return (
    <span
      data-testid={fits ? "budget-fit-chip" : "budget-over-chip"}
      title={fits
        ? `Total degree cost ${format(cost)} fits inside your ${format(budget)} envelope.`
        : `Total degree cost ${format(cost)} is ${format(over)} over your ${format(budget)} envelope.`}
      className={`inline-flex items-center gap-1 font-underground-sc tracking-wider rounded-full border ${sizing} ${
        fits
          ? "bg-emerald-50 text-emerald-800 border-emerald-200"
          : "bg-amber-50 text-amber-800 border-amber-200"
      }`}
    >
      {fits ? "fits budget" : `over by ${format(over)}`}
    </span>
  );
}
